<template>
  <div>
    <the-navbar :sellerInfo="sellerInfo" />
    <base-telephone
      v-if="sellerInfo.phone"
      :phone-number="sellerInfo.phone"
      class="float-button left"
    >
      <i class="fas fa-mobile-alt" />
    </base-telephone>
    <base-sms v-if="sellerInfo.phone" :phone-number="sellerInfo.phone" class="float-button right">
      <i class="far fa-comments" />
    </base-sms>
    <main class="mt-4">
      <slot></slot>
    </main>
    <welcome-modal
      :seller-info="sellerInfo"
      :welcome-message="welcomeMessage"
      :user-firstname="lead.firstname"
      @userStarted="sentOpen"
    />
    <loader v-if="showAppLoader" />
  </div>
</template>

<script>
import { watch, ref } from '@vue/composition-api';
import { mapState } from 'vuex';
import { useModal } from '@/composable/wrappers';
import TheNavbar from '@/components/the-navbar';
import BaseTelephone from '@/components/base-telephone';
import BaseSms from '@/components/base-sms';
import Loader from '@/components/app-loader';
import WelcomeModal from '@/components/welcome-modal';
import useActionMessage from '@/composable/useActionMessage';
import { ACTION_STATUS } from '@/constants';

export default {
  name: 'DefaultLayout',
  components: {
    BaseTelephone,
    BaseSms,
    TheNavbar,
    Loader,
    WelcomeModal,
  },
  props: {
    lead: {
      type: Object,
      default: () => ({}),
    },
    rooftop: {
      type: Object,
      default: () => ({}),
    },
    welcomeMessage: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { sentOpen, actionOwner, actionStatus } = useActionMessage();

    const modal = useModal();
    // To make sure the modal shows once and not everytime the watch runs
    const hasWatcherRun = ref(false);
    watch(actionStatus, (status) => {
      if (status !== ACTION_STATUS.SUBMITTED && !hasWatcherRun.value) {
        modal.show('welcome-modal');
      }
      hasWatcherRun.value = true;
    });

    return {
      sentOpen,
      actionOwner,
    };
  },
  computed: {
    ...mapState(['showAppLoader']),
    sellerInfo() {
      return {
        fullName: this.actionOwner?.full_name || '',
        firstName: this.actionOwner?.firstname || '',
        photo: this.actionOwner?.photo?.url || '',
        phone: this.actionOwner?.phone,
        email: this.actionOwner?.email,
        rooftopName: this.rooftop.name || '',
        rooftopLogo: this.rooftop.logo_url || '',
      };
    },
  },
};
</script>
